import { createSlice, PayloadAction } from '@reduxjs/toolkit';
 
interface SearchRetainState {   
  firstName: string;
  lastName: string;
  participantName: string; 
  userPage: number;
  userRowsPerPage: number;
  userSearchFlag: boolean;
}

const initialState: SearchRetainState = {   
  firstName: '',
  lastName: '',
  participantName: '', 
  userPage:0,
  userRowsPerPage:5,
  userSearchFlag: false
};

const authSlice = createSlice({
  name: 'searchRetain',
  initialState,
  reducers: {
    // Action to store login details
    setSearchDetails: (state, action: PayloadAction<Partial<SearchRetainState>>) => {
      return { ...state, ...action.payload };
    },
    // Action to reset auth details (used only when logging out)
    resetSearchDetails: () => initialState,
    // Action to set error message, if needed
    setSearchError: (state, action: PayloadAction<string>) => {
      // Optionally, you can handle error state here
    },
  },
});

export const { setSearchDetails, resetSearchDetails, setSearchError } = authSlice.actions;
export default authSlice.reducer;
